var _linearGradient, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 40 24",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "master",
    gradientUnits: "objectBoundingBox",
    x1: 0.5,
    x2: 0.5,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#306fc5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b6ba8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -79.451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m40 101.394a2.227 2.227 0 0 1 -2.364 2.057h-35.272a2.227 2.227 0 0 1 -2.364-2.057v-19.886a2.227 2.227 0 0 1 2.364-2.057h35.272a2.227 2.227 0 0 1 2.364 2.057z",
    fill: "url(#master)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.681 101.394v-19.886a2.227 2.227 0 0 1 2.365-2.057h-1.682a2.227 2.227 0 0 0 -2.364 2.057v19.886a2.227 2.227 0 0 0 2.364 2.057h1.682a2.227 2.227 0 0 1 -2.365-2.057z",
    fill: "#202121",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "m215.971 108.395a7.2 7.2 0 1 1 -14.371 0 7.2 7.2 0 1 1 14.371 0z",
    fill: "#ffb600",
    transform: "translate(-183.06 -17.273)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.786 100.8a7.418 7.418 0 0 1 7.186 7.595 7.2 7.2 0 1 1 -14.371 0",
    fill: "#f7981d",
    transform: "translate(-183.06 -17.273)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352.8 100.8a7.418 7.418 0 0 1 7.186 7.595 7.393 7.393 0 0 1 -7.186 7.595",
    fill: "#ff8500",
    transform: "translate(-327.074 -17.273)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.11 100.8a7.609 7.609 0 0 0 .076 15.19 7.056 7.056 0 0 0 4.829-1.969 7.069 7.069 0 0 0 .722-.8h-1.483a9.262 9.262 0 0 1 -.532-.764h2.547a5.243 5.243 0 0 0 .418-.8h-3.387a4.952 4.952 0 0 1 -.3-.8h3.954a8.393 8.393 0 0 0 .38-2.411 10.944 10.944 0 0 0 -.152-1.607h-4.411a6.151 6.151 0 0 1 .19-.8h3.954a4.952 4.952 0 0 0 -.3-.8h-3.35a8.117 8.117 0 0 1 .418-.8h2.547a3.812 3.812 0 0 0 -.57-.8h-1.406a6.678 6.678 0 0 1 .722-.764 6.811 6.811 0 0 0 -4.829-1.969c.001-.106.001-.106-.037-.106z",
    fill: "#ff5050",
    transform: "translate(7.595 -17.273)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 109.917a7.4 7.4 0 0 0 7.186 7.6 7.055 7.055 0 0 0 4.829-1.97 7.071 7.071 0 0 0 .722-.8h-1.483a9.264 9.264 0 0 1 -.532-.764h2.547a5.244 5.244 0 0 0 .418-.8h-3.387a4.954 4.954 0 0 1 -.3-.8h3.954a8.4 8.4 0 0 0 .38-2.412 10.95 10.95 0 0 0 -.152-1.608h-4.411a6.155 6.155 0 0 1 .19-.8h3.954a4.954 4.954 0 0 0 -.3-.8h-3.35a8.12 8.12 0 0 1 .418-.8h2.547a3.813 3.813 0 0 0 -.57-.8h-1.406a6.678 6.678 0 0 1 .722-.764 6.81 6.81 0 0 0 -4.829-1.97h-.037",
    fill: "#e52836",
    transform: "translate(7.595 -18.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149.676 117.514a7.054 7.054 0 0 0 4.829-1.97 7.072 7.072 0 0 0 .722-.8h-1.483a9.27 9.27 0 0 1 -.532-.764h2.547a5.245 5.245 0 0 0 .418-.8h-3.384a4.954 4.954 0 0 1 -.3-.8h3.954a8.4 8.4 0 0 0 .38-2.412 10.949 10.949 0 0 0 -.152-1.608h-4.41a6.156 6.156 0 0 1 .19-.8h3.954a4.957 4.957 0 0 0 -.3-.8h-3.346a8.122 8.122 0 0 1 .418-.8h2.547a3.815 3.815 0 0 0 -.57-.8h-1.407a6.678 6.678 0 0 1 .722-.764 6.81 6.81 0 0 0 -4.829-1.97h-.044",
    fill: "#cb2026",
    transform: "translate(-134.316 -18.797)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m182.7 223.346.114-.646a1.645 1.645 0 0 1 -.19.038c-.266 0-.3-.152-.266-.228l.228-1.331h.418l.114-.722h-.38l.076-.456h-.76s-.456 2.509-.456 2.813a.571.571 0 0 0 .608.646 1.167 1.167 0 0 0 .494-.114z",
    transform: "translate(-164.86 -130.396)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210.4 230.414a1.209 1.209 0 0 0 1.331 1.331 1.974 1.974 0 0 0 .8-.114l.152-.722a2.279 2.279 0 0 1 -.8.19c-.836 0-.684-.608-.684-.608h1.559a4.929 4.929 0 0 0 .114-.684 1.03 1.03 0 0 0 -1.1-1.1c-.802-.08-1.372.757-1.372 1.707zm1.331-1.1c.418 0 .342.494.342.532h-.836c-.001-.04.075-.534.494-.534z",
    transform: "translate(-192.174 -138.681)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m298.091 216.488.152-.836a1.868 1.868 0 0 1 -.646.19c-.532 0-.76-.418-.76-.874 0-.912.456-1.407.988-1.407a1.27 1.27 0 0 1 .684.228l.114-.8a2.673 2.673 0 0 0 -.874-.19c-.874 0-1.749.76-1.749 2.205 0 .951.456 1.6 1.369 1.6a3.411 3.411 0 0 0 .722-.116z",
    transform: "translate(-273.424 -123.538)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.845 227.2a2.693 2.693 0 0 0 -.912.152l-.114.646a2.248 2.248 0 0 1 .836-.152c.266 0 .494.038.494.266 0 .152-.038.19-.038.19h-.342c-.646 0-1.369.266-1.369 1.141 0 .684.456.836.722.836a1.142 1.142 0 0 0 .8-.342l-.038.3h.684l.3-2.091a.9.9 0 0 0 -1.023-.946zm.155 1.711c0 .114-.076.722-.532.722a.3.3 0 0 1 -.3-.3c0-.19.114-.456.684-.456a.6.6 0 0 0 .148.034z",
    transform: "translate(-74.467 -137.254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.074 229.518a.974.974 0 0 0 1.141-.989c0-.95-.912-.76-.912-1.141 0-.19.152-.266.418-.266.114 0 .532.038.532.038l.114-.684a2.888 2.888 0 0 0 -.722-.076c-.57 0-1.141.228-1.141.989 0 .874.951.8.951 1.141 0 .228-.266.266-.456.266a2.486 2.486 0 0 1 -.684-.114l-.114.684c.037.076.227.152.873.152z",
    transform: "translate(-120.796 -136.492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m429.367 214.4-.152 1.027a1.054 1.054 0 0 0 -.722-.38c-.684 0-1.293.836-1.293 1.825 0 .608.3 1.255.951 1.255a1.015 1.015 0 0 0 .722-.3l-.038.266h.76l.57-3.65zm-.342 2.015c0 .418-.19.951-.608.951-.266 0-.418-.228-.418-.608 0-.608.266-.989.608-.989.266 0 .418.19.418.646z",
    transform: "translate(-397.939 -125.062)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.122 218.05.456-2.737.076 2.737h.532l.989-2.737-.418 2.737h.8l.608-3.65h-1.256l-.76 2.243-.038-2.243h-1.1l-.608 3.65z",
    transform: "translate(-6.121 -125.062)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260.836 231.766c.228-1.255.266-2.281.8-2.091a2.985 2.985 0 0 1 .266-.874h-.152c-.342 0-.608.456-.608.456l.076-.418h-.722l-.496 2.961h.836z",
    transform: "translate(-239.279 -138.778)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m347.845 227.2a2.693 2.693 0 0 0 -.912.152l-.114.646a2.247 2.247 0 0 1 .836-.152c.266 0 .494.038.494.266 0 .152-.038.19-.038.19h-.342c-.646 0-1.369.266-1.369 1.141 0 .684.456.836.722.836a1.142 1.142 0 0 0 .8-.342l-.038.3h.684l.3-2.091a.888.888 0 0 0 -1.023-.946zm.19 1.711c0 .114-.076.722-.532.722a.3.3 0 0 1 -.3-.3c0-.19.114-.456.684-.456.113.034.113.034.148.034z",
    transform: "translate(-321.273 -137.254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395.236 231.766c.228-1.255.266-2.281.8-2.091a2.985 2.985 0 0 1 .266-.874h-.152c-.342 0-.608.456-.608.456l.076-.418h-.722l-.496 2.961h.836z",
    transform: "translate(-366.698 -138.778)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m180 222.813a.571.571 0 0 0 .608.646 1.447 1.447 0 0 0 .57-.114l.114-.646a1.647 1.647 0 0 1 -.19.038c-.266 0-.3-.152-.266-.228l.228-1.331h.418l.114-.722h-.38l.076-.456",
    fill: "#dce5e5",
    transform: "translate(-163.339 -130.396)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.4 230.414c0 1.065.342 1.331.951 1.331a1.974 1.974 0 0 0 .8-.114l.152-.722a2.279 2.279 0 0 1 -.8.19c-.836 0-.684-.608-.684-.608h1.559a4.929 4.929 0 0 0 .114-.684 1.03 1.03 0 0 0 -1.1-1.1c-.802-.08-.992.757-.992 1.707zm.951-1.1c.418 0 .494.494.494.532h-.989c0-.04.076-.534.494-.534z",
    fill: "#dce5e5",
    transform: "translate(-199.781 -138.681)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305.711 216.488.152-.836a1.868 1.868 0 0 1 -.646.19c-.532 0-.76-.418-.76-.874 0-.912.456-1.407.989-1.407a1.27 1.27 0 0 1 .684.228l.114-.8a2.673 2.673 0 0 0 -.874-.19c-.874 0-1.369.76-1.369 2.205 0 .951.076 1.6.988 1.6a3.411 3.411 0 0 0 .722-.116z",
    fill: "#dce5e5",
    transform: "translate(-281.035 -123.538)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.818 229.56a2.247 2.247 0 0 1 .836-.152c.266 0 .494.038.494.266 0 .152-.038.19-.038.19h-.342c-.646 0-1.369.266-1.369 1.141 0 .684.456.836.722.836a1.142 1.142 0 0 0 .8-.342l-.038.3h.684l.3-2.091c0-.874-.76-.912-1.065-.912m.57 1.635a1.245 1.245 0 0 1 -.912.722.3.3 0 0 1 -.3-.3c0-.19.114-.456.684-.456a3.106 3.106 0 0 0 .533.038z",
    fill: "#dce5e5",
    transform: "translate(-74.467 -138.778)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136 229.442a3.218 3.218 0 0 0 .874.076.974.974 0 0 0 1.141-.989c0-.95-.912-.76-.912-1.141 0-.19.152-.266.418-.266.114 0 .532.038.532.038l.114-.684a2.888 2.888 0 0 0 -.722-.076c-.57 0-.76.228-.76.989 0 .874.57.8.57 1.141 0 .228-.266.266-.456.266",
    fill: "#dce5e5",
    transform: "translate(-121.556 -136.492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m436.78 216.189a1.054 1.054 0 0 0 -.722-.38c-.684 0-.912.836-.912 1.825 0 .608-.076 1.255.57 1.255a1.015 1.015 0 0 0 .722-.3l-.038.266h.76l.57-3.65m-.989 1.977c0 .418-.342.95-.76.95-.266 0-.418-.228-.418-.608 0-.608.266-.989.608-.989a.581.581 0 0 1 .571.642z",
    fill: "#dce5e5",
    transform: "translate(-405.503 -125.824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.122 218.05.456-2.737.076 2.737h.532l.989-2.737-.418 2.737h.8l.608-3.65h-.95l-1.065 2.243-.038-2.243h-.418l-1.294 3.65z",
    fill: "#dce5e5",
    transform: "translate(-6.121 -125.062)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260.8 231.766h.8c.228-1.255.266-2.281.8-2.091a2.985 2.985 0 0 1 .266-.874h-.152c-.342 0-.608.456-.608.456l.076-.418",
    fill: "#dce5e5",
    transform: "translate(-240.04 -138.778)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.818 229.56a2.247 2.247 0 0 1 .836-.152c.266 0 .494.038.494.266 0 .152-.038.19-.038.19h-.342c-.646 0-1.369.266-1.369 1.141 0 .684.456.836.722.836a1.142 1.142 0 0 0 .8-.342l-.038.3h.684l.3-2.091c0-.874-.76-.912-1.065-.912m.57 1.635a1.245 1.245 0 0 1 -.913.722.3.3 0 0 1 -.3-.3c0-.19.114-.456.684-.456a3.344 3.344 0 0 0 .534.038z",
    fill: "#dce5e5",
    transform: "translate(-321.273 -138.778)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395.2 231.766h.8c.228-1.255.266-2.281.8-2.091a2.983 2.983 0 0 1 .266-.874h-.152c-.342 0-.608.456-.608.456l.076-.418",
    fill: "#dce5e5",
    transform: "translate(-367.46 -138.778)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaster);
export default __webpack_public_path__ + "static/media/master.ae47a7ed5c16ac983f422dc439b38fbf.svg";
export { ForwardRef as ReactComponent };